import { TransactionEntryFieldsFragment } from '../graphql/generated';
import { dt } from '../util/dateTime';
import { sampleTransactionEntries } from './transactionEntries';

export const getSampleTransactionEntries = (() => {
    // Set sample data to start last month
    const monthsFromSampleData =
        Math.ceil(dt().diff(dt('2024-02-01'), 'month', false)) - 1;

    const memoizedEntries: TransactionEntryFieldsFragment[] =
        sampleTransactionEntries
            .map((t) => ({
                ...t,
                date: dt(t.date)
                    .add(monthsFromSampleData, 'months')
                    .toDateStr(),
            }))
            .filter((t) => t.date <= dt().toDateStr());

    return () => memoizedEntries;
})();
